import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
import RTPOhero from "../components/rtpo/RTPOhero";
 
import RTPO from "../components/rtpo/RTPO";
import { Header, Footer } from "../shared";

const RTPOPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      {/* <RTPOhero /> */}
      <RTPO />

      <Footer />
    </div>
  );
};

export default RTPOPage;
